module.exports = __webpack_public_path__ + "static/media/reflective-listening-large@3x.ea25cced.png";